/* eslint-disable import/named */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* eslint-disable indent */
// Libraries

import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

import {
    getDependentSectionName,
    getFormButtonText,
} from '../../utils/helperMethods';
import { FormElems, Alert, AlertModal } from '../../components/';
import {
    SUCCESS_MESSAGES,
    ERROR_MESSAGES,
} from '../../utils/constants/toastMessages';

import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
    submitStepFormRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';

import {
    resetUpdateDataSuccessKey,
    getMerchantInfoRequest,
    fetchBasicFormData,
    updateSectionDataRequest,
    addMerchantStepUpdateMakerRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';

// import validate from './validator';
import {
    API_UPLOAD_KYC_DOCUMENT,
    API_VIEW_KYC_DOCUMENT,
} from '../../utils/API/apiUrls';

import { POST } from '../../utils/fetchWrappers';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';

import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, change, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { last, first, isEmpty } from 'lodash';
// Component
// Actions
// Constant
// Validator
// Styles
import './KYCTab.scss';
import { multipleAdditionalDoc, singleAdditionalDoc } from './contants';
import FileUploadField from 'components/FileUploadField';
import { handleDeleteFile, handleUploadKycImage } from '../../components/Onboarding/Mle/mle.utils';
import {PREFIX_KYCURLS} from '../../components/Onboarding/Mle/BusinessTab/contants'
import ImageViewModal from 'components/Onboarding/Mle/BusinessTab/ImageViewModal';
import kycResponse from './kyc.res';
import infoIcon from "../../static/images/blackinfo.png";
import Tooltip from 'rc-tooltip';
import * as loaderActions from '../../redux/common/loader/loader.actions';

const allowedExtensions = ['jpg', 'jpeg', 'png'];

let checkerRemarks = {
    PCI_DSS: {
        name: "PCI_DSS",
        remarks: "Verify PCI DSS Certificate Expiry Date on changing PCI DSS Certificate"
    }
}

function validateDocuments(data, validationRules) {
    let errors = [];

    validationRules.forEach(rule => {
        let docType = rule.docType;
        let isMandatory = rule.isMandatory;
        let multipleDoc = rule.multipleDoc;
        let maxCount = rule.maxDocCount;
        let minCount = rule.minDocCount;

        let docs = data[docType] || [];

        if (!Array.isArray(docs)) {
            docs = [docs];
        }

        let docCount = docs.filter(Boolean).length;

        if (isMandatory && docCount === 0) {
            errors.push(`${rule.docName} is mandatory but missing.`);
        }

        if (minCount > 0 && docCount < minCount) {
            errors.push(`${rule.docName} requires at least ${minCount} document(s). Found ${docCount}.`);
        }

        if (maxCount > 0 && docCount > maxCount) {
            errors.push(`${rule.docName} allows a maximum of ${maxCount} document(s). Found ${docCount}.`);
        }

        if (!multipleDoc && docCount > 1) {
            errors.push(`${rule.docName} allows only one document, but multiple were provided.`);
        }
    });

    return errors;
}

const KYCTab = ({
    merchantData,
    handleSubmit,
    nextPath,
    previousPath,
    history,
    actions,
    sectionType,
    name,
    auth,
    initialValues,
    isEditMode,
    isViewMode,
    editData,
    draftData,
    onBoardSteps,
    formData,
}) => {
    const {
        saveData,
        timeline: { fields },
        formInProcess = [],
        uniqueIdentifier: { uniqueId },
    } = merchantData;

    const isOldData = initialValues.panUrl && initialValues.aadharUrl && initialValues.dlUrl && initialValues.passPortUrl && initialValues.voterIdUrl && initialValues.eBillUrl && (isEditMode || isViewMode);

    const { updateData, basicFormData = {}, sections = [] } = editData;
    const { userDetails } = auth;
    const { location } = history;
    const [isUploading, setIsUploading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const isUserTerminalState = !nextPath;

    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );

    const [isChange, setIsChange] = useState(false);
    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';
    const [isShowModal, setIsShowModal] = useState(false);
    const [docUrls, setDocUrls] = useState({});

    const [additionalDocsInitial, setAdditionalDocInitial] = useState({});
    const [additionalDocs, setAdditionalDoc] = useState({
        BR: [],
        MEA: [],
        WEB_CRAWLING: [],
    });

    const onSuccessModal = () => {
        setIsShowModal(false);
        if (formData && formData.values) {
            handleFormSubmit(formData.values);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    const onNext = () => {
        resetErrors();
        if (!isUserTerminalState) {
            history.push(nextPath);
        } else {
            history.push('/mob');
        }
    };

    const onBack = () => {
        resetErrors();
        if (!isEditMode && !isViewMode && draftData && editData) {
            history.push('/mob/draft');
        } else {
            history.push(previousPath);
        }
    };

    useEffect(() => {
        const merchantId = last(location.pathname.split('/'));

        if ((isEditMode || isViewMode) && fields?.length) {
            actions.getMerchantInfoRequest(merchantId, fields);
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        setDocUrls(initialValues);
        if (initialValues.additionalDocs) {
            setAdditionalDoc({ ...initialValues.additionalDocs });
            setAdditionalDocInitial({ ...initialValues.additionalDocs });
            Object.keys(initialValues.additionalDocs).map(item => {
                actions.change(
                    'kyc-form',
                    item,
                    initialValues.additionalDocs[item]
                );
            });
        }
    }, [initialValues]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const handleFormSubmit = values => {
        const { websiteUrl } = values;
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            isChange &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const request = {
                uniqueIdentifier: uniqueId,
                sectionType,
                userId: userDetails.email,
                formType: 'merchantOnboardingForm',
                data: {
                    ...docUrls,
                    additionalDocs,
                    websiteUrl: websiteUrl || null,
                },
            };

            if (isEmpty(docUrls) && isOldData && isEditMode) {
                toast.error('PAN, Aadhar, Driving License, Passport, voter ID and Electricity Bill are mandatory!');
                return;
            }

            if (
                [
                    'panUrl',
                    'aadharUrl',
                    'dlUrl',
                    'passPortUrl',
                    'voterIdUrl',
                    'eBillUrl',
                ].some(item => isEmpty(docUrls[item]) && isOldData && isEditMode)
            ) {
                toast.error('PAN, Aadhar, Driving License, Passport, voter ID and Electricity Bill are mandatory!');
                return;
            }

            const items = editData?.basicFormData?.kycDocuments || [];

            const errors = validateDocuments(additionalDocs, items);

            if(errors.length > 0) {
                errors.forEach(error => {
                    toast.error(error);
                });
                return;
            }

            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));
                const updateRequest = {
                    configurationType: 'KYC',
                    entityCode: merchantId || '',
                    merchantConfig: {
                        kycData: {
                            ...docUrls,
                            additionalDocs,
                            websiteUrl: websiteUrl || null,
                        },
                    },
                };
                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.KYC,
                };

                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails
                );
            } else if (isViewMode) {
                onNext();
            } else {
                if (isUserTerminalState) {
                    actions.submitStepFormRequest(request, sectionType);
                } else {
                    actions.saveAndContinueRequest(request, sectionType);
                }
            }
        }
    };

    async function uploadImageAndGetURL(file, name) {
        const formData = new FormData();
        formData.append('multipartFile', file);
        if (isEditMode) {
            const merchantId = last(location.pathname.split('/'));
            formData.append('merchantId', merchantId);
        } else {
            formData.append('uniqueIdentifier', uniqueId);
        }
        const headers = {
            'Content-Type': 'multipart/form-data;',
        };
        actions.showLoader();
        console.log('CALLED');
        try {
            const response = await POST(
                API_UPLOAD_KYC_DOCUMENT,
                formData,
                headers,
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                toast.info('File upload successful');
                return data.s3Path;
            }
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }finally {
            actions.hideLoader();
        }
    }
    async function handleViewClick(docUrl, setIsUploading, setSelectedDocument) {
        const request = {
            s3Path: Array.isArray(docUrl) ? docUrl[0] : docUrl,
        };
        setIsUploading(true);
        actions.showLoader();
        try {

            const response = await POST(
                API_VIEW_KYC_DOCUMENT,
                request,
                {},
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                if (setSelectedDocument)
                    setSelectedDocument(data.s3Url);
                    return data.s3Url;
            } else {
                toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            }
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);

        }finally {
            actions.hideLoader();
            setIsUploading(false);
        }

    }

    const errorDetails = isEditMode ? updateData : saveData;

    useEffect(() => {
        let req = {};
        const merchantId = last(location.pathname.split("/"));
        if (isEditMode || isViewMode) {
            req = {
                sectionType,
                formType: "merchantOnboardingForm",
                entityCode: merchantId,
            };
        } else {
            req = {
                uniqueIdentifier: uniqueId,
                formType: "merchantOnboardingForm",
                sectionType,
            };
        }
        actions.fetchBasicFormData(req);
    }, [
        actions,
        userDetails?.email,
        isEditMode,
        isViewMode,
        sectionType,
        formInProcess,
        uniqueId,
        location.pathname,
    ]);

    const handleFileChange = (name, value) => {
        const newDocMap = Object.assign({}, docUrls);
        newDocMap[name] = value;
        setDocUrls({ ...newDocMap });
        setIsChange(true);
    };


    const kycDocumentsNew = useMemo(() => {
        const chunks = [];
        const items = editData?.basicFormData?.kycDocuments || [];

        for (let i = 0; i < items.length; i += 2) {
            chunks.push(items.slice(i, i + 2));
        }

        return chunks.map((chunk, index) => (
            <li className="form-section" key={index}>
                {chunk.map((item, idx) => (
                    <React.Fragment key={idx}>
                        <div className="form-field">
                            <FileUploadField
                                checkerRemarks={isEditMode ? checkerRemarks : null }
                                initialValue={additionalDocsInitial[item.docType]}
                                docUrls={additionalDocs}
                                setDocUrls={setAdditionalDoc}
                                itemInfo={item}
                                prefix={() => {}}
                                prefixReqName={''}
                                handleUploadImageAndGetUrl={file =>
                                    handleUploadKycImage(
                                        file,
                                        setIsUploading,
                                        actions,
                                        item.multipleDoc ? `${PREFIX_KYCURLS}.${item.docType}` : null,
                                        'kyc-form'
                                    )
                                }
                                handleViewClick={docUrl =>
                                    handleViewClick(docUrl, setIsUploading, setSelectedDocument)
                                }
                                actions={actions}
                                change={change}
                                handleDeleteFile={() => handleDeleteFile()}
                                values={formData?.values ?? {}}
                                required={item.isMandatory}
                                multi={item.multipleDoc}
                                formName="kyc-form"
                                isViewMode={isViewMode}
                            />
                        </div>
                    </React.Fragment>
                ))}
            </li>
        ));
    }, [editData, additionalDocsInitial, additionalDocs, setAdditionalDoc, actions, change, formData, isViewMode, handleUploadKycImage, handleViewClick, handleDeleteFile, setIsUploading, setSelectedDocument]);


    const kycDocumentsOld = useMemo(() => (
        <React.Fragment>
            <li className="form-section">
                <div className="form-field">
                    <p className="label">Pan Card</p>
                    <Field
                        name="panUrl"
                        type="file"
                        id="pan-card"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Pan Card"
                        disabled={isViewMode}
                        accept="image/*"
                        handleChange={handleFileChange}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        allowedExtensions={allowedExtensions}
                        docUrl={docUrls.panUrl}
                    />
                </div>
                <div className="form-field">
                    <p className="label">Aadhar Card</p>
                    <Field
                        name="aadharUrl"
                        type="file"
                        id="aadhar-card"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Aadhar Card"
                        disabled={isViewMode}
                        accept="image/*"
                        handleChange={handleFileChange}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        allowedExtensions={allowedExtensions}
                        docUrl={docUrls.aadharUrl}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                    />
                </div>
            </li>
            <li className="form-section">
                <div className="form-field">
                    <p className="label">Driving License</p>
                    <Field
                        name="dlUrl"
                        type="file"
                        id="driving-license"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Driving License"
                        disabled={isViewMode}
                        accept="image/*"
                        handleChange={handleFileChange}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        allowedExtensions={allowedExtensions}
                        docUrl={docUrls.dlUrl}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                    />
                </div>
                <div className="form-field">
                    <p className="label">Passport</p>
                    <Field
                        name="passPortUrl"
                        type="file"
                        id="passPortUrl"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Passport"
                        disabled={isViewMode}
                        accept="image/*"
                        handleChange={handleFileChange}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        docUrl={docUrls.passPortUrl}
                        allowedExtensions={allowedExtensions}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                    />
                </div>
            </li>
            <li className="form-section">
                <div className="form-field">
                    <p className="label">Voter ID</p>
                    <Field
                        name="voterIdUrl"
                        type="file"
                        id="voterid-card"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Voter ID"
                        disabled={isViewMode}
                        accept="image/*"
                        handleChange={handleFileChange}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        allowedExtensions={allowedExtensions}
                        docUrl={docUrls.voterIdUrl}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                    />
                </div>
                <div className="form-field">
                    <p className="label">Electricity Bill</p>
                    <Field
                        name="eBillUrl"
                        type="file"
                        id="eBillUrl-card"
                        component={FormElems.UploadElement}
                        placeholder="Upload Your Electricity Bill"
                        disabled={isViewMode}
                        accept="image/*"
                        allowedExtensions={allowedExtensions}
                        handleChange={handleFileChange}
                        uploadImageAndGetURL={uploadImageAndGetURL}
                        docUrl={docUrls.eBillUrl}
                        handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                    />
                </div>
            </li>
            <li className="form-section">
                {singleAdditionalDoc.map((item, index) => (
                    <div className="single-form-section" key={index}>
                        <FieldArray
                            name={item.name}
                            configuration={item}
                            component={RenderMultiUpload}
                            isViewMode={isViewMode}
                            onlySingleFile
                            uploadImageAndGetURL={uploadImageAndGetURL}
                            handleView={(url) => handleViewClick(url, setIsUploading, setSelectedDocument)}
                            docUrls={additionalDocs}
                            setDocUrls={setAdditionalDoc}
                        />
                    </div>
                ))}
            </li>
        </React.Fragment>
    ), [isViewMode, handleFileChange, handleViewClick, uploadImageAndGetURL, docUrls, additionalDocs, setAdditionalDoc, setIsUploading, setSelectedDocument]);

    return (
        <div className="kyc-tab">
            <form
                className="kyc-detail-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <ImageViewModal
                    selectedDocument={selectedDocument}
                    setSelectedDocument={setSelectedDocument}
                />
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    onSuccessModal={onSuccessModal}
                    currentSection={currentStep}
                    message={`${getDependentSectionName(
                        onBoardSteps,
                        currentStep.dependentSections
                    )}
                    ${isOrAre} dependent on ${currentStep.name}
                    section. Please update dependent sections.`}
                />
                <div className="kyc-details card">
                    <h2 className="tab-title">Merchant Docs</h2>
                    {errorDetails.error && errorDetails.error.errorMessage ? (
                        <Alert customClass="error-msg">
                            {errorDetails.error.errorMessage}
                        </Alert>
                    ) : null}
                    <ul className="form-list">
                        {isOldData ? kycDocumentsOld : null}
                        {kycDocumentsNew}
                        {
                            isOldData && (
                                <React.Fragment>
                                    <li className="form-section">
                                        {multipleAdditionalDoc.map((item, index) => (
                                            <div className="multiple-form-section" key={index}>
                                                <FieldArray
                                                    name={item.name}
                                                    configuration={item}
                                                    component={RenderMultiUpload}
                                                    isViewMode={isViewMode}
                                                    uploadImageAndGetURL={uploadImageAndGetURL}
                                                    handleViewClick={handleViewClick}
                                                    docUrls={additionalDocs}
                                                    setDocUrls={setAdditionalDoc}
                                                    setIsUploading={setIsUploading}
                                                    setSelectedDocument={setSelectedDocument}
                                                />
                                            </div>
                                        ))}
                                    </li>
                                    <li className="form-section website-url-section">
                                        <FieldArray
                                            name="websiteUrl"
                                            component={multiField}
                                            isViewMode={isViewMode}
                                        />
                                        <div className="form-field"></div>
                                    </li>
                                </React.Fragment>
                            )
                        }
                    </ul>
                </div>
                <div className="form-section action">
                    {!isViewMode &&(
                        <>
                        <FormElems.Button
                            buttonType="secondary"
                            text="BACK"
                            type="button"
                            id="back-btn"
                            handleClick={onBack}
                            customClass="back-btn"
                        />
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            text={getFormButtonText(isUserTerminalState)}
                        />
                    </>
                    )}
                </div>
            </form>
        </div>
    );
};

const multiField = ({ fields, meta: { error, submitFailed }, isViewMode }) => {
    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <>
            {fields.map((field, index) => {
                return (
                    <div key={index} className="form-field">
                        <p className="label">Website URL</p>
                        <Field
                            id={`websiteUrl-${index}`}
                            name={`${field}`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Website URL"
                            disabled={isViewMode}
                        />
                    </div>
                );
            })}
        </>
    );
};

const RenderMultiUpload = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
    configuration,
    handleViewClick,
    uploadImageAndGetURL,
    docUrls,
    setDocUrls,
    onlySingleFile,
    setIsUploading,
    setSelectedDocument
}) => {

    const handleFileChange = (name, value, index) => {
        if (value) {
            const newDocMap = { ...docUrls };
            newDocMap[configuration.name][index] = value;
            setDocUrls(newDocMap);
        }
    };

    const handleView = (url) => {
        console.log(handleViewClick, url);
        if (handleViewClick) {
            return handleViewClick(url, setIsUploading, setSelectedDocument);
        }
    };

    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <div
            className={`field-array-section ${
                onlySingleFile ? 'no-border' : ''
            } form-section`}
        >
            <div className="field-list-section">
                {fields.map((item, index) => (
                    <>
                        <div className="field-list">
                            <div className="form-field">
                                {index > 0 ? (
                                    <></>
                                ) : (
                                    <p className="label">
                                        {configuration.label}
                                    </p>
                                )}
                                <Field
                                    handleChange={(name, value) =>
                                        handleFileChange(name, value, index)
                                    }
                                    uploadImageAndGetURL={uploadImageAndGetURL}
                                    docUrl={docUrls && docUrls[configuration.name] ? docUrls[configuration.name][index] : null}
                                    handleView={handleView}
                                    name={item}
                                    id={item}
                                    type="file"
                                    component={FormElems.UploadElement}
                                    placeholder={
                                        configuration.props.placeholder
                                    }
                                    disabled={isViewMode}
                                    accept={configuration.props.accept}
                                    allowedExtensions={allowedExtensions}
                                />
                            </div>
                            {!onlySingleFile && !isViewMode && index !== 0 && (
                                <div className="action-container">
                                    <div className="action remove">
                                        <FormElems.Button
                                            type="button"
                                            text={'x Remove'}
                                            buttonType="secondary"
                                            id={`removeNumber-${index}`}
                                            customClass="remove-button"
                                            handleClick={() => fields.remove(index)}
                                            disabled={isViewMode}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                ))}
                {
                    !(isViewMode || onlySingleFile) && (
                        <div className="action-container">
                            <div className="action">
                                <FormElems.Button
                                    type="button"
                                    buttonType="secondary"
                                    id="add-document"
                                    text={`+ Add ${configuration.label}`}
                                    customClass="add-button"
                                    isDisable={fields.length === 10}
                                    handleClick={() => {
                                        fields.push();
                                    }}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

// Update PropTypes to include the new props
RenderMultiUpload.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    configuration: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
    isEditMode: PropTypes.bool,
    onlySingleFile: PropTypes.bool,
    handleViewClick: PropTypes.func,
    uploadImageAndGetURL: PropTypes.func,
    docUrls: PropTypes.object,
    setDocUrls: PropTypes.func,
    setIsUploading: PropTypes.func,
    setSelectedDocument: PropTypes.func,
    handleViewClick2: PropTypes.func,
};


KYCTab.propTypes = {
    actions: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
    draftData: PropTypes.object,
    staticData: PropTypes.object,
    onBoardSteps: PropTypes.array,
    isInEditMode: PropTypes.bool,
    isCheckerMode: PropTypes.bool,
    isEditCheckerMode: PropTypes.bool,
    makerCheckerData: PropTypes.object,
};
const mapStateToProps = ({
    auth,
    form,
    merchantData,
    editData,
    staticData,
    makerCheckerData,
}) => ({
    auth,
    formData: form['kyc-form'],
    merchantData,
    editData,
    staticData,
    makerCheckerData,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            saveAndContinueRequest,
            submitStepFormRequest,
            updateSectionDataRequest,
            resetSaveDataSuccessKey,
            resetUpdateDataSuccessKey,
            getMerchantInfoRequest,
            addMerchantStepUpdateMakerRequest,
            fetchBasicFormData,
            change,
            showLoader: loaderActions.showLoader,
            hideLoader: loaderActions.hideLoader
        },
        dispatch
    ),
});
export default withRouter(
    compose(
        reduxForm({
            form: 'kyc-form',
            enableReinitialize: true,
            // validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(KYCTab)
);
